"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardValidator = void 0;
var _validator = _interopRequireDefault(require("validator"));
var CreditCardValidator = exports.CreditCardValidator = {
  number: function number(v) {
    return v.length > 12 && v.length < 17 && _validator["default"].isNumeric(v, {
      no_symbols: true
    });
  },
  name: function name(v) {
    return v.length > 1 && v.length <= 64;
  },
  expiration: function expiration(v) {
    return /\d\d\/\d\d/.test(v);
  },
  // MM/YY
  cvc: function cvc(v) {
    return v.length === 3 && _validator["default"].isNumeric(v, {
      no_symbols: true
    });
  },
  zip: function zip(v) {
    return v.length === 5 && _validator["default"].isNumeric(v, {
      no_symbols: true
    });
  }
};